// https://git.huya.info/huyafed/components/huyafed-npm/-/tree/master/packages/taf-network
import TafNetwork from "@huyafed/taf-network/dist/taf-network.cjs.prod.js";
import {
  checkTafResponse,
  createTafRuntime,
  createTimingMiddleware,
  createUserIdMiddleware,
  getTafErrorMessage,
  type TafMiddleware,
  type TafRequest,
  type TafTransport,
} from "@huyafed/gametool-taf-runtime";
import Constants from "@/constants";
import { HUYA } from "@/assets/jce/LuckyBagServant";
import { getUserId } from "@/api/getUserId";
import * as kiwiSdk from "@huyafed/huya-kiwi";

type TBase = {
  bcode: number;
  sdkcode: number;
  [key: string]: any;
};
type TafClassIgnoreKey = "_clone" | "_write" | "_read" | "writeTo" | "readFrom";
export type ClassType = new (...args: any) => any;
type GT<T> = T extends ClassType ? T : any;
export type TReqParams<TReqClass extends any | ClassType> = TReqClass extends ClassType
  ? Partial<Omit<InstanceType<TReqClass>, TafClassIgnoreKey>>
  : Partial<Omit<TReqClass, TafClassIgnoreKey>>;
export type TRspInfer<T extends any> = T extends ClassType ? InstanceType<T> : T;
export type TRspWrap<T> = T & TBase;
export type TTafFetch = <TRspClass extends any = any, TReqClass extends any = any>(params: {
  moduleName: string;
  funcName: string;
  ReqClass: GT<TReqClass>;
  RspClass: GT<TRspClass>;
  data: TReqParams<TReqClass>;
  timeoutMS?: number;
  useSendWupWithForceUa?: boolean;
}) => Promise<TRspWrap<TRspInfer<TRspClass>>>;

const uris = {
  6700: HUYA.LuckyBagPanel,
};

export const timeOutSeconds = 10;

export const tafSdk = new TafNetwork({
  showLog: Constants.IS_DEBUG || Constants.IS_USEDEBUG,
  // taf-network 的 isDebug 表示测试接口环境，不是日志开关。
  isDebug: Constants.IS_TAF_TEST,
  uris,
  tryTime: timeOutSeconds,
  kiwiSdk,
});

type TUris = typeof uris;
export function listenNotice<TUri extends keyof TUris>(
  uri: TUri,
  cb: (jceStruct: TRspInfer<TUris[TUri]>) => any,
  pid?: string | number,
): Function {
  if (Number(pid)) {
    // @ts-ignore
    tafSdk.pid = pid;
  }
  tafSdk.addListener(uri, cb);
  tafSdk.listen();
  // @ts-ignore
  return () => tafSdk.clearSingleListen(uri);
}

const debugEnabled = Constants.IS_DEBUG || Constants.IS_USEDEBUG;
const middlewares: TafMiddleware[] = [
  ...(debugEnabled ? [createTimingMiddleware()] : []),
  createUserIdMiddleware({
    getUserId,
    exclude: ["huyauserui.getUserProfile"],
  }),
];
const runtimeTafFetch = createTafRuntime({
  transport: tafSdk as unknown as TafTransport,
  timeoutMS: timeOutSeconds * 1000,
  middlewares,
});

export const tafFetch = Object.assign(
  ((params =>
    runtimeTafFetch(params as unknown as TafRequest)) as TTafFetch),
  {
    getTaf: () => runtimeTafFetch.getTaf(),
  },
);

export default tafFetch;

export const getErrorMsgFromSDK = (
  res: Awaited<ReturnType<TTafFetch>>,
  prefixErrorMsg?: string,
) =>
  getTafErrorMessage(
    res,
    prefixErrorMsg || "网络繁忙，请稍后再试",
    debugEnabled,
  );

export const checkRes = (
  res: { bcode: number; sdkcode: number; [key: string]: any },
  prefixErrorMsg?: string,
) => {
  checkTafResponse(res, prefixErrorMsg, debugEnabled);
};
